/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Track pair Setting DTO
 */
export interface TrackPairSettingDto {
  id: number;
  hours: number;
  disabled: boolean;
}
